import MomentUtils from '@date-io/moment';
import CircularProgress from '@material-ui/core/CircularProgress';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import { ThemeProvider } from '@material-ui/styles';
import { OktaAuth, toRelativeUrl } from '@okta/okta-auth-js';
import { LoginCallback, Security } from '@okta/okta-react';
import { createBrowserHistory } from 'history';
import React, { Suspense, useEffect } from 'react';
import { isMobile, mobileModel } from 'react-device-detect';
import 'react-perfect-scrollbar/dist/css/styles.css';
import { Provider as StoreProvider } from 'react-redux';
import { Route, Router, Switch } from 'react-router-dom';
import { PersistGate } from 'redux-persist/integration/react';
import { publishLocation } from 'src/utils/Common';
import { oktaClientId, oktaIssuer } from 'src/utils/contants';
import './assets/css/google.css';
import './assets/scss/main.scss';
import GoogleAnalytics from './components/GoogleAnalytics';
import ScrollReset from './components/ScrollReset';
import StylesProvider from './components/StylesProvider';
import Auth from './layouts/Auth';
import './modules/mixins/chartjs';
import './modules/mixins/moment';
import './modules/mixins/prismjs';
import './modules/mixins/validate';
import { theme } from './modules/theme';
import { configureStore } from './store';
import './signalr/translation';
import NotificationSnackbar from './components/NotificationSnackbar';
import { SnackbarProvider } from 'notistack';
import { store } from './store/configureAppStore'
import ThuliumProvider from './views/Overview/PhoneCallDialog/ThuliumProvider';

const { persistor } = configureStore();
const history = createBrowserHistory();

const config = {
  issuer: oktaIssuer,
  redirectUri: `${window.location.origin}/implicit/callback`,
  clientId: oktaClientId,
  pkce: true,
  scopes: ['openid', 'email', 'profile'],
  cookies: {
    secure: false
  }
};

const oktaAuth = new OktaAuth(config);

const restoreOriginalUri = async (_oktaAuth, originalUri) => {
  history.replace(toRelativeUrl(originalUri, window.location.origin));
};

if (isMobile && mobileModel === 'iPhone') {
  setInterval(() => {
    publishLocation(0);
  }, 10000);
}

const THULIUM_SIGNALR_URL =
  process.env.REACT_APP_THULIUM_SIGNALR_URL ||
  (process.env.REACT_APP_BACKEND_URL
    ? `${process.env.REACT_APP_BACKEND_URL.replace(/\/$/, '')}/phoneCallHub`
    : '');
function App() {
  useEffect(() => {
    if (!history.location.pathname.includes('/implicit/callback') && history.location.pathname.length > 1) {
      localStorage.setItem(
        'redirect',
        JSON.stringify({
          pathname: history.location.pathname,
          hash: history.location.hash,
          state: {
            redirect: `${history.location.pathname}${history.location.hash}`
          }
        })
      );
    }
  }, []);
  return (
    <Suspense fallback={null}>
      <StoreProvider store={store}>
        <SnackbarProvider maxSnack={1}>
          <PersistGate
            loading={<CircularProgress status="loading" />}
            persistor={persistor}
          >
            <ThemeProvider theme={theme}>


              <StylesProvider direction="ltr">
                <MuiPickersUtilsProvider utils={MomentUtils}>
                  <Router history={history}>
                    <ScrollReset />
                    <GoogleAnalytics />
                    <Security
                      oktaAuth={oktaAuth}
                      restoreOriginalUri={restoreOriginalUri}
                    >
                      <ThuliumProvider gatewayUrl={THULIUM_SIGNALR_URL}>
                      <Switch>
                        <Route
                          exact
                          path="/implicit/callback"
                          component={LoginCallback}
                        />

                        <Route path="/" component={Auth} />

                      </Switch>
                      </ThuliumProvider>
                    </Security>
                  </Router>
                </MuiPickersUtilsProvider>
              </StylesProvider>
            </ThemeProvider>
          </PersistGate>
        </SnackbarProvider>
      </StoreProvider>
    </Suspense>
  );
}

export default App;
